import { RepeatIcon } from '@buffer-mono/popcorn'

import { PostCardNotice } from './PostCardNotice'
import { usePostRecurrenceInfo } from './usePostRecurrenceInfo'

import type { JSX } from 'react'

export function PostCardRecurrenceNotice(): JSX.Element | null {
  const recurrenceInfo = usePostRecurrenceInfo()

  if (!recurrenceInfo) return null

  const Icon = <RepeatIcon color="subtle" />

  return (
    <PostCardNotice variant="neutral" icon={Icon}>
      {recurrenceInfo.summary}
    </PostCardNotice>
  )
}
